import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user/userSlice";
import adminReducer from "./admin/adminSlice";
import hrReducer from "./hr/hrSlice";
import rankingReducer from "./ranking/rankingSlice";
import placementReducer from "./placements/placementSlice";
import { batchApi } from "../store/batchApi";
import { studentApi } from "../store/studentApi";
import { courseApi } from "./courseApi";
import { enquiryApi } from "./enquiryApi";
import { feeApi } from "./feeApi";
import { attendenceApi } from "./attendenceApi";
import { productApi } from "./projectApi";
import { portfolioApi } from "./portfolioApi";
import { expancesApi } from "./expancesApi";
import { ChangPasswordApi } from "./ChangPasswordApi";
import { expenseCategoryApi } from "./ExpenseCategoryApi";
import { videoApi } from "./videoApi";
import { adminAuthApi } from "./adminAuthApi";

import { notificationApi } from "./notificationApi";
import { resourcesApi } from "./resourcesApi";

import { hrApi } from "./hrAuth";
import { instructorApi } from "./instructorApi";
import { interviewApi } from "./instructor/interview";
import { assignmentApi } from "./assignmentApi";
import { submissionApi } from "./submissionApi";
import { rankingApi } from "./ranking/rankingApi";
import { benefitApi } from "./benefitApi";
import { benefitCategoryApi } from "./benefitCategoryApi";

export const store = configureStore({
  reducer: {
    user: userReducer,
    admin: adminReducer,
    hr: hrReducer,
    ranking: rankingReducer,
    placement: placementReducer,
    [batchApi.reducerPath]: batchApi.reducer,
    [studentApi.reducerPath]: studentApi.reducer,
    [courseApi.reducerPath]: courseApi.reducer,
    [enquiryApi.reducerPath]: enquiryApi.reducer,
    [feeApi.reducerPath]: feeApi.reducer,
    [attendenceApi.reducerPath]: attendenceApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [portfolioApi.reducerPath]: portfolioApi.reducer,
    [expancesApi.reducerPath]: expancesApi.reducer,
    [ChangPasswordApi.reducerPath]: ChangPasswordApi.reducer,
    [expenseCategoryApi.reducerPath]: expenseCategoryApi.reducer,
    [videoApi.reducerPath]: videoApi.reducer,
    [adminAuthApi.reducerPath]: adminAuthApi.reducer,

    [notificationApi.reducerPath]: notificationApi.reducer,
    [resourcesApi.reducerPath]: resourcesApi.reducer,

    [hrApi.reducerPath]: hrApi.reducer,
    [instructorApi.reducerPath]: instructorApi.reducer,
    [interviewApi.reducerPath]: interviewApi.reducer,
    [assignmentApi.reducerPath]: assignmentApi.reducer,
    [submissionApi.reducerPath]: submissionApi.reducer,
    [rankingApi.reducerPath]: rankingApi.reducer,
    [benefitApi.reducerPath]: benefitApi.reducer,
    [benefitCategoryApi.reducerPath]: benefitCategoryApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      batchApi.middleware,
      studentApi.middleware,
      courseApi.middleware,
      enquiryApi.middleware,
      feeApi.middleware,
      attendenceApi.middleware,
      productApi.middleware,
      portfolioApi.middleware,
      expancesApi.middleware,
      ChangPasswordApi.middleware,
      expenseCategoryApi.middleware,
      videoApi.middleware,
      adminAuthApi.middleware,
      notificationApi.middleware,
      resourcesApi.middleware,
      hrApi.middleware,
      instructorApi.middleware,
      interviewApi.middleware,
      assignmentApi.middleware,
      submissionApi.middleware,
      rankingApi.middleware,
      benefitApi.middleware,
      benefitCategoryApi.middleware
    ),
});

